import React from 'react'
import { withRouter } from 'react-router-dom'
import { formatDiscoverLatestTimestamp } from '../../utils/formatDiscoverLatestTimestamp'
import { calculatePlayCount } from '../../utils/calculatePlayCount'
import TopPageHeader from '../pageHeaders/TopPageHeader'
import DiscoverSeeAllRepoLink from './DiscoverSeeAllRepoLink'
import Icon from '../misc/Icons'
import { searchDiscoverRepos } from '../../services/search/discoverSearchService'

// the page name doubles as the sort order
const SORTS = ['latest', 'popular', 'rated']
const REPOS_PER_PAGE = 50

class DiscoverSeeAllPage extends React.Component {
  constructor(props) {
    super(props)
    this.getRepos = this.getRepos.bind(this)
    this.state = {
      repos: [],
    }
  }

  componentDidMount() {
    this.getRepos()
  }

  getRepos() {
    const { subject, page: sort } = this.props
    if (!SORTS.includes(sort)) return

    searchDiscoverRepos({ subject, sort, limit: REPOS_PER_PAGE })
      .then((hits) => {
        this.setState({ repos: hits })
      })
      // leave whatever is on screen rather than flashing to empty
      .catch(() => {})
  }

  render() {
    const { subject, page } = this.props
    let formattedSubject
    if (subject === 'earlyMath') {
      formattedSubject = 'Early Math'
    }
    if (subject === 'biology') {
      formattedSubject = 'High School Biology'
    }

    let formattedPage
    if (page === 'latest') {
      formattedPage = 'Latest Packs'
    }
    if (page === 'popular') {
      formattedPage = 'Most Popular Packs'
    }
    if (page === 'rated') {
      formattedPage = 'Highest Rated Packs'
    }

    return (
      <div className='page page--wideLayout discoverSeeAllPage'>
        <div className='page-leftPanel' />
        <div className='page-centerPanel'>
          <TopPageHeader
            location='discoverSeeAll'
            leftBadge={<Icon name='chevron-left' />}
            leftBadgeClickFunction={() => { this.props.history.push(`/discover/${subject}`) }}
            header={formattedPage}
            subHeader={formattedSubject}
          />
          <div className='discoverSeeAllPage-repoList'>
            {this.state.repos.map((repo) => (
              <DiscoverSeeAllRepoLink
                key={repo.id}
                repo={repo}
                rating={repo.rating}
                seeAllPage={page}
                playCount={calculatePlayCount(repo.responseCount)}
                loadRepoContent={this.props.loadRepoContent}
                timestamp={formatDiscoverLatestTimestamp(repo.publishedAt)}
              />
            ))}
          </div>
        </div>
        <div className='page-rightPanel' />
      </div>
    )
  }
}

export default withRouter(DiscoverSeeAllPage)
